import { FunctionComponent } from 'react';

import { faChevronRight } from '@fortawesome/pro-solid-svg-icons';
import styled from 'styled-components';

import { Icon } from 'core/ui';

type WorklistSidebarCollapsedProps = {
  handleShowSidebar: () => void;
  selectedWorklistName?: string | null;
};

export const WorklistSidebarCollapsed: FunctionComponent<WorklistSidebarCollapsedProps> = ({ handleShowSidebar, selectedWorklistName }) => {
  // Transform "All Files" to "Categories" for better UX
  const displayName = selectedWorklistName === 'All Files' ? 'Categories' : selectedWorklistName;

  return (
    <StyledWrapperDiv onClick={handleShowSidebar}>
      <StyledTitleDiv>{displayName || 'Filter'}</StyledTitleDiv>
      <StyledIconContainer>
        <Icon icon={faChevronRight} />
      </StyledIconContainer>
    </StyledWrapperDiv>
  );
};

const StyledTitleDiv = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: ${({ theme }) => theme.fontSizes.subheading};
  font-weight: ${({ theme }) => theme.fontWeights.semiBold};
  color: white; /* Ensure white text */
`;

const StyledIconContainer = styled.div`
  display: flex;
  align-items: center;
  color: white; /* White icon to match text */
  transition: transform 0.2s ease;
`;

const StyledWrapperDiv = styled.div`
  background: ${({ theme }) => theme.colors.primary};
  color: white;
  display: flex;
  align-items: center;
  font-weight: ${({ theme }) => theme.fontWeights.semiBold};
  justify-content: space-between;
  padding: ${({ theme }) => theme.space.spacing20} ${({ theme }) => theme.space.spacing30};
  margin-right: ${({ theme }) => theme.space.spacing20};
  width: 250px;
  z-index: 1;
  cursor: pointer;
  border-radius: ${({ theme }) => theme.radii.base};
  border: 1px solid ${({ theme }) => theme.colors.primary};
  transition: all 0.2s ease;
  box-shadow: 0 2px 4px rgba(0, 123, 255, 0.2);

  &:hover {
    background-color: ${({ theme }) => theme.colors.palette.blues[7]};
    border-color: ${({ theme }) => theme.colors.palette.blues[7]};
    box-shadow: 0 4px 8px rgba(0, 123, 255, 0.3);
    transform: translateY(-1px);

    ${StyledIconContainer} {
      transform: translateX(3px);
      color: white;
    }
  }

  /* Mobile adjustments - full screen width when expanded */
  @media (max-width: 768px) {
    width: 100%;
    position: relative;
    z-index: 10;
    font-size: 1.25rem;
    padding: 0.75rem 1rem;
    margin-right: 0;
  }
`;
